<template>
  <div class="container col-10">
    <v-dialog
      v-model="dialogStart"
      fullscreen
      hide-overlay
      :retain-focus="false"
      persistent
      transition="dialog-bottom-transition"
    >
      <v-card>
        <v-toolbar dark color="secondary">
          <v-btn icon dark class="btn btn-primary" @click="closeDialog()">
            <v-icon>mdi-close</v-icon>
          </v-btn>
          <v-toolbar-title>Estrellas por plantilla</v-toolbar-title>

          <template v-slot:extension>
            <v-tabs v-model="tab" align-with-title>
              <v-tabs-slider color="accent"></v-tabs-slider>
              <v-tab v-for="item in items" :key="item">
                {{ item }}
              </v-tab>
            </v-tabs>
          </template>
        </v-toolbar>

        <v-tabs-items v-model="tab" class="container mt-5">
          <v-tab-item>
            <div v-if="loading" class="text-center" style="margin-bottom: 30px;">
            <v-progress-circular
              class="mt-auto"
              :size="70"
              :width="7"
              color="primary"
              indeterminate
            ></v-progress-circular>
          </div>
            <div v-else class="container mt-4">
              <v-data-table
                :headers="headers"
                :items="listHistoricalTemplateDispersal"
                :header-props="{ class: 'red-header' }"
                :search="searchTerm"
              >
                <!-- Sección superior de la tabla -->
                <template v-slot:top>
                  <div style="margin-bottom: 50px">
                    <div class="row justify-space-between mx-auto">
                      <v-text-field
                        label="Buscador"
                        placeholder="Ingrese por favor una palabra"
                        append-icon="mdi-magnify"
                        dense
                        outlined
                        class="col-md-5"
                        @input="search"
                      ></v-text-field>

                      <div class="downloadButtons">
                        <v-btn
                          x-medium
                          large
                          block
                          rounded
                          color="primary"
                          dark
                          style="width: 200px"
                          @click="postDownloadTemplateRedirect()"
                        >
                          Descargar Plantilla
                        </v-btn>

                        <v-btn
                          x-medium
                          large
                          block
                          rounded
                          color="primary"
                          dark
                          style="width: 200px"
                          @click="modelPostTemplate()"
                        >
                          Subir Archivo
                        </v-btn>
                      </div>
                    </div>
                  </div>
                </template>

                <template v-slot:[`item.assigmentReportId`]="{ item }">
                  <span class="custom-font">{{ item.assigmentReportId }}</span>
                </template>

                <template v-slot:[`item.creationDate`]="{ item }">
                  <span class="custom-font">{{ formatDate(item.creationDate) }}</span>
                </template>

                <template v-slot:[`item.numberUsers`]="{ item }">
                  <span class="custom-font">{{ item.numberUsers }}</span>
                </template>

                <template v-slot:[`item.requestStatus`]="{ item }">
                  <span class="custom-font">{{ item.requestStatus }}</span>
                </template>

                <template v-slot:[`item.action`]="{ item }">
                  <v-icon color="primary" size="x-large"></v-icon>

                  <div class="actions">
                    <v-tooltip top>
                      <template v-slot:activator="{ on, attrs }">
                        <v-btn
                          icon
                          x-large
                          dark
                          text
                          v-bind="attrs"
                          v-on="on"
                          color="primary"
                          @click="redirectToDownload(item.linkFile)"
                          style="
                            background-color: transparent;
                            margin-left: 1vh;
                          "
                        >
                          <v-icon color="primary">mdi-download</v-icon>
                        </v-btn>
                      </template>
                      <span>Descargar</span>
                    </v-tooltip>
                  </div>
                </template>
              </v-data-table>
            </div>
          </v-tab-item>
        </v-tabs-items>
      </v-card>
    </v-dialog>

    <v-dialog
      v-model="dialogMonetization"
      transition="dialog-bottom-transition"
      max-width="600"
      persistent
    >
      <template>
        <v-card class="container justify-content-between align-items-center">
          <button class="close-button" @click="closeDialogModel()">
            <span class="small-x">X</span>
          </button>
          <v-col cols="12" md="12" sm="12">
            <img
              src="https://ibliss-icons-prod.s3.us-east-1.amazonaws.com/marca_empresarial/image-welcomeDefault.png"
              class="custom-img"
            />
          </v-col>
          <div >
            <h2 class="custom-title">Cargar Plantilla</h2>
            <p class="custom-text" style="text-align: center">
              Por favor adjuntar el archivo que confirma el proceso de tu
              dispersión.
            </p>
            <v-form ref="form" class="pr-5 pl-5">
              <v-file-input
                v-model="fileModel"
                label="Cargar archivo Excel"
                accept=".xls,.xlsx"
                show-size
                outlined
                counter
                @change="handleFileUpload"
              ></v-file-input>
            </v-form>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn
                x-medium
                large
                rounded
                color="primary"
                :disabled="!isFormValid"
                @click="postConfirm()"
              >
                Enviar
              </v-btn>
            </v-card-actions>
          </div>
        </v-card>
      </template>
    </v-dialog>
  </div>
</template>

<script>
import Swal from "sweetalert2";

import {
  STARASSIGNMENT_M,
  GET_LIST_HISTORICAL_TEMPLATE,
  GET_DOWNLOAD_TEMPLATE,
  GET_STATE_LOADING,
  ACTION_GET_LIST_HISTORICAL_TEMPLATE,
  ACTION_POST_TEMPLATE,
  ACTION_DOWNLOAD_TEMPLATE,
} from "@/views/star_assignment/store/types/types.js";

import { mapActions, mapGetters } from "vuex";

export default {
  name: "detailReportComponent",
  props: {
    dialogStart: {
      required: true,
    },
  },

  data() {
    return {
      formData: {
        startDate: null,
        endDate: null,
        company: null,
        email: null,
      },
      tab: "defaultTabValue",
      items: ["Datos Completos"],
      searchTerm: "",
      fileModel: null,
      monetizationReportId: 0,
      isFormValid: null,
      activePicker: null,
      activePicker2: null,
      menuStartDate: false,
      menuEndDate: false,
      totalRegistros: 20,
      modoRules: [(v) => !!v || "El modo de la categoría es requerido"],
      showErrorMessages: false,
      dialogMonetization: false,
    };
  },

  watch: {
    menuStartDate(val) {
      val && setTimeout(() => (this.activePicker = "YEAR"));
    },

    menuEndDate(val) {
      val && setTimeout(() => (this.activePicker2 = "YEAR"));
    },
  },

  async mounted() {
    await this.getListHistoricalTemplate();
    console.log("qqqqqqqqqqqqq ", this.loading);
  },

  computed: {
    headers() {
      return [
        {
          text: "Código de monetización",
          value: "assigmentReportId",
          align: "center",
          sortable: false,
          class:
            "primary--text text-h1 text-md-h5 text-lg-h5 custom-header font-weight-medium text-subtitle-1",
        },
        {
          text: "Fecha de inicio del proceso",
          value: "creationDate",
          align: "center",
          sortable: false,
          class:
            "primary--text text-h1 text-md-h5 text-lg-h5 custom-header font-weight-medium text-subtitle-1 my-custom-font",
        },
        {
          text: "Cantidad de solicitudes",
          value: "numberUsers",
          align: "center",
          sortable: false,
          class:
            "primary--text text-h1 text-md-h5 text-lg-h5 custom-header font-weight-medium text-subtitle-1",
        },
        {
          text: "Estado de solicitud",
          value: "requestStatus",
          align: "center",
          sortable: false,
          class:
            "primary--text text-h1 text-md-h5 text-lg-h5 custom-header font-weight-medium text-subtitle-1",
        },
        {
          value: "action",
          sortable: false,
          align: "center",
          //class: "custom-header mdi-pencil text-subtitle-1",
        },
      ];
    },

    ...mapGetters({
      listHistoricalTemplateDispersal: `${STARASSIGNMENT_M}${GET_LIST_HISTORICAL_TEMPLATE}`,
      downloadTemplateDispersal: `${STARASSIGNMENT_M}${GET_DOWNLOAD_TEMPLATE}`,
      loading: `${STARASSIGNMENT_M}${GET_STATE_LOADING}`,
    }),
  },

  methods: {
    search() {
      // Actualiza el término de búsqueda
      this.searchTerm = event.target.value;
    },

    modelPostTemplate() {
      this.dialogMonetization = true;
    },

    closeDialog() {
      this.selectedFile = null;
      this.isFormValid = false;
      this.fileModel = null;
      this.dialogStart = false;
      window.location.reload();
    },

    closeDialogModel() {
      this.selectedFile = null;
      this.isFormValid = false;
      this.fileModel = null;
      this.dialogMonetization = false;
    },

    handleFileUpload(file) {
      if (file) {
        this.isFormValid = true;
      } else {
        this.isFormValid = false;
      }

      const allowedTypes = [
        "application/vnd.ms-excel",
        "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet", // .xlsx
      ];

      if (!allowedTypes.includes(file.type)) {
        Swal.fire({
          icon: "error",
          title: "Formato inválido",
          text: "Solo se permiten archivos en formato .xls o .xlsx.",
        });
        return;
      }
      this.selectedFile = file;
    },

    async postConfirm() {
      const formdata = new FormData();
      formdata.append("fileReport", this.selectedFile);

      this.closeDialogModel();
      const monetization = await this.postScatterStarsTemplates(formdata);
      this.selectedFile = null;
      if (monetization) {
        if (monetization.data.payload) {
          await Swal.fire({
            text: monetization.data.payload.message,
            icon: "success",
            confirmButtonText: "OK",
          });
        } else {
          await Swal.fire({
            text: monetization.data.payload.message,
            icon: "error",
            confirmButtonText: "OK",
          });
        }

        await this.getListHistoricalTemplate();

        this.selectedFile = null;
        this.isFormValid = false;
        this.fileModel = null;
        this.dialogMonetization = false;
      }
    },

    redirectToDownload(link) {
      window.open(link, "_blank");
    },

    async postDownloadTemplateRedirect() {
      const link = await this.postDownloadTemplate();
      console.log("Link descarga ", link);
      this.redirectToDownload(link.data.payload);
    },

    formatDate(dateString) {
      return dateString.split("T")[0];
    },

    ...mapActions({
      getListHistoricalTemplate: `${STARASSIGNMENT_M}${ACTION_GET_LIST_HISTORICAL_TEMPLATE}`,
      postScatterStarsTemplates: `${STARASSIGNMENT_M}${ACTION_POST_TEMPLATE}`,
      postDownloadTemplate: `${STARASSIGNMENT_M}${ACTION_DOWNLOAD_TEMPLATE}`,
    }),
  },
};
</script>

<style lang="css" scoped>
h1,
h2,
h3,
h4,
h5,
h6 {
  font-family: "Amsi Pro", sans-serif;
  color: #2d0049;
  font-weight: normal;
}

.downloadButtons {
  display: flex;
  gap: 10px;
  width: 240px;
  margin-right: 240px;
}

.headerReport {
  display: flex;
  gap: 40px;
  flex-direction: column;
  margin: 40px 0 40px;
}

.custom-font {
  font-size: 20px;
}

.actions {
  display: inline-flex;
}

.container {
  position: relative;
}

.custom-img {
  width: 170px;
  height: auto;
  display: block;
  margin: 0 auto;
}

.custom-title {
  color: #6e17a5;
  justify-items: center;
  text-align: center;
  font-size: 33px;
  font-weight: bolder;
  margin-bottom: 7px;
}

.custom-text {
  color: #6e17a5;
  justify-items: center;
  text-align: center;
  font-size: 20px;
  margin-bottom: 25px;
}

.small-x {
  font-size: x-large;
  color: #6e17a5;
}

.close-button {
  position: absolute;
  top: 5px;
  right: 10px;
  background: none;
  border: none;
  cursor: pointer;
}

/*Resposive*/

/* Tablet y menor */
@media screen and (max-width: 768px) {
  .formReport {
    display: flex;
    gap: 40px;
    flex-direction: column;
    justify-content: center;
  }
}

/* Teléfonos medianos */
@media screen and (max-width: 550px) {
  .headerReport {
    margin: 40px 10px;
  }
  .downloadButtons {
    display: grid;
    margin: initial;
    width: 250px;
  }
}

/* Teléfonos pequeños */
@media screen and (max-width: 425px) {
  .formReport {
    display: flex;
    gap: 50px;
    flex-direction: column;
    justify-content: center;
  }
}
</style>
